<template>
  <v-app id="products" v-if="product">
    <v-content>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" class="mt-12" flat>
            <v-row class="mx-1">
              <v-col cols="12" md="6" lg="6" xl="6">
                <div class="pa-5 bg-white-light shadow-custom mr-2" style="height:100%;">
                  <v-img
                    contain
                    class="productImage mx-auto img-fluid bg-white-light"
                    :src="getImage(product.slug)"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <div class="pa-5 bg-white-light shadow-custom">
                  <v-card-title class="pa-2 mt-10 pt-5">
                    <h2
                      class="font-weight-black groen mb-1"
                      style=" margin: 0 auto;font-size: 43px;"
                    >{{product.name}}</h2>
                  </v-card-title>

                  <div class="ma-2">
                    <div id="description" class="ma-5 pt-5">
                      <p>{{product.description}}</p>
                    </div>

                    <div id="orderChecklist">
                      <v-list disabled>
                        <v-list-item-group v-model="rule" color="primary">
                          <v-list-item
                            class="ml-0 pl-0"
                            v-for="(rule, i) in product.order_cons"
                            :key="i"
                          >
                            <v-list-item-icon style="margin-left:10px; margin-bottom:5px;">
                              <v-icon
                                v-text="rule.icon"
                                style="color:#00d89e;"
                                class="font-weight-bold"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="rule.text" color="primary" class="mt-2"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>

                    <div class="product-price mt-6 mb-2 text-center">
                      <span class="special-price">€ {{product.price}}</span>
                      <span>/ per maand</span>
                    </div>

                    <div class="availability pt-4">
                      <h2
                        class="overline my-2 font-weight-bold"
                        style="font-size:13px !important;"
                      >Op voorraad</h2>
                      <!-- :style="products[p_id].voorraad == 'Op voorraad' ? 'color: #01d89e !important;' : 'color: #f33 !important;'" -->
                    </div>

                    <div class="my-5">
                      <v-btn
                        rounded
                        :color="'#00d89e'"
                        class="white--text"
                        block
                        :to="{ 'path' : `/p/${p_id}` }"
                      >
                        <v-icon left>mdi-cart</v-icon>Nu bestellen
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-container>
            <v-row class="my-2 mx-1">
              <v-col cols="12">
                <v-tabs grow background-color="'#128934'" v-model="model">
                  <v-tab>Omschrijving</v-tab>
                  <v-tab>Specificaties</v-tab>
                  <v-tab>FAQ</v-tab>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <p class="pa-4">{{product.description}}</p>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-list disabled>
                          <v-subheader>
                            <h2 class="text-uppercase">Het {{product.name}} model:</h2>
                          </v-subheader>
                          <v-list-item-group color="primary" v-model="rule">
                            <v-list-item v-for="(rule, i) in product.specifications" :key="i">
                              <v-list-item-icon>
                                <v-icon>{{rule.icon}}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{rule.text}}</v-list-item-title>
                                <v-list-item-subtitle>{{rule.subtitle}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text></v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>

            <v-row class="my-5 mx-2" v-if="random">
              <v-col cols="4">
                <h2 class="text-uppercase blauw pb-5">Gerelateerd:</h2>
                <v-card
                  flat
                  color="transparent"
                  ripple
                  hover
                  :to="{'path': `/products/${random.id}`}"
                  style="min-width: 300px;"
                >
                  <v-col cols="12" class="my-auto text-center white">
                    <h2 style="font-size:1.75rem" class="mb-5">{{random.name}}</h2>
                    <v-list-item-avatar size="185" tile>
                      <v-img
                        :src="random.image"
                      ></v-img>
                    </v-list-item-avatar>
                    <div class="product-price mt-6 mb-2 text-center">
                      <span class="special-price">€ {{random.price}}</span>
                      <span>/ per maand</span>
                    </div>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  components: {},
  data: () => ({
    p_id: null,
    r_id: null,
    foo: 1,
    model: 1,
    qtyRules: [v => v >= 1 || "Aantal kan niet kleiner dan 1"],
    item: null,
    rule: null,
    mijnProduct: null
  }),
  methods: {
    ...mapActions("plans", ["_getPlan", "_getRandom"]),
    getRandomProduct(i) {
      var productArray = [1, 2, 3, 4].filter(function(x) {
        return x !== Number(i);
      });
      this.r_id = productArray[Math.floor(Math.random() * productArray.length)];
    },
    getImage(slug){
      var img = require.context('../../assets/steps', false);
      return img('./' + slug + '.png');
    },
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  },
  computed: {
    ...mapState({
      product: state => state.plans.current,
      random: state => state.plans.random
    })
  },
  created() {
    const planId = this.$route.params.id;
    this.getRandomProduct(planId);
    this.p_id = planId;

    this._getPlan(planId)
      .then(() => {
        console.log("getproduct success");
      })
      .catch(e => console.log(e));

    this._getRandom(this.r_id)
      .then(() => {
        console.log(this.random);
      })
      .catch(e => console.log(e));
    this.toTop();
  }
};
</script>

<style src="./Products.scss" scoped lang="scss"></style>
